import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"

const CardItem = (props) => {
    const { index, item, Service, updateHandler, status, setShouldGetData } = props
    const [deleteModal, setDeleteModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [itemStatus, setItemStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]

    useEffect(() => {
        setItemStatus(status)
    }, [status])
    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }

    const changeStatus = (e) => {
        setLoading(true)
        const value = e.target.checked
        service.toggleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                toast.success("Status Changed Successfully")
                setItemStatus(value)
                toast.success(res.data.success)
                setLoading(false)
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000)
            }
        })
    }
    return (
        <tr key={index} className="payment-bgBadge">
            <td className='font-size-14'>{item.id}</td>
            <th className='font-size-14  ' style={{ textDecoration: "underline", fontWeight: 700 }}>{item.name.en}</th>
            <th className='font-size-14'> {item.compounds ?.map((comp, index) => {
                return (
                    <Badge
                        key={index}
                        className="bgBadge font-size-14 mt-0 m-1"
                        style={{ background: "#50a5f1", marginTop: "0px !important" }}
                    >
                        {comp.name.en}
                    </Badge>
                )
            })}</th>
            <td className='font-size-14 py-0'>
                <form>
                    <div className='form-check form-switch form-switch-md mb-1'>
                        <input
                            name='status'
                            checked={itemStatus}
                            type='checkbox'
                            className='form-check-input'
                            id='has_status'
                            onChange={changeStatus}
                            disabled={!isExist('edit_compound')}
                        />
                    </div>
                </form>
            </td>
            <td className="removebtnhover">
                {(isExist('edit_compound') || isExist('delete_compound')) &&<Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                        {isExist('edit_compound') &&<DropdownItem onClick={updateHandler}>Edit</DropdownItem>}
                        {isExist('delete_compound') &&<DropdownItem className="text-danger" onClick={() => {
                            setDeleteModal(!deleteModal)
                        }}>Remove Payment Plan</DropdownItem>}
                    </DropdownMenu>
                </Dropdown>}
            </td>
            <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </tr>


    )
}

export default CardItem